export const RECEIPT_HEAD = [
  { k: 'workflow', v: 'claim.review · pharma' },
  { k: 'trigger matched', v: 'performance language' },
  { k: 'passes', v: '1 · approved first pass' },
]

export const RECEIPT_RULES = [
  { id: 'disclosure.safety', v: 'v3.2' },
  { id: 'claims.no-guarantee', v: 'v3.2' },
  { id: 'format.hcp-letter', v: 'v1.9' },
  { id: 'language.approved-only', v: 'v4.1' },
  { id: 'review.medical-legal', v: 'v2.0' },
  { id: 'retention.audit-trail', v: 'v1.4' },
  { id: 'house.med-info-voice', v: 'v2.3' },
]

export const AGENT_STEPS = [
  { n: '1' },
  { n: '2' },
  { n: '3', kind: 'omit' as const },
  { n: '4' },
  { n: '5' },
  { n: '6' },
  { n: '7', kind: 'commit' as const },
]
